import React from 'react';
import Button from "semantic-ui-react/dist/es/elements/Button/Button.js";
import { Icon } from "../../../elements/Icon";
export var renderNavButton = function renderNavButton(iconName) {
  return function (onClick, disabled) {
    return React.createElement(Button, {
      circular: true,
      content: null,
      disabled: disabled,
      onClick: onClick,
      primary: true
    }, React.createElement(Icon, {
      isColorInverted: true,
      name: iconName
    }));
  };
};